import React, { useState } from 'react'
import { El } from '../Layout/style'
import { useTranslation } from 'react-i18next'
import { DownloadService } from '~/api/services/downloadFiles'
import { Button, ButtonProps, Icon, Popup, SemanticICONS } from 'semantic-ui-react'
import { getUsersBrowserData, handleErrors } from '~/utils/helpers'
import { PopupWrapper } from './style'

interface ExcelExportProps {
  name?: string
  url: string
  fileName: string
  data?: any
  buttonType?: 'button' | 'action' | 'popup' | 'icon'
  icon?: string
  popupContent?: string
  downloadWithFileName?: boolean
}

type ExcelExportComponentProps = ExcelExportProps & ButtonProps

const ExcelExport: React.FC<ExcelExportComponentProps> = (props) => {
  const { url, fileName, data, downloadWithFileName, buttonType, icon, ...buttonProps } = props
  const { t } = useTranslation()
  const [loadingExport, setLoadingExport] = useState(false)

  async function handleExport() {
    setLoadingExport(true)
    try {
      const userData = getUsersBrowserData()
      if (!downloadWithFileName) {
        await DownloadService.downloadFile(url, fileName, { ...userData, ...data })
      } else if (downloadWithFileName) {
        await DownloadService.downloadFileWithName(url, { ...data })
      }
    } catch (error) {
      setLoadingExport(false)
      handleErrors(error)
    }
    setLoadingExport(false)
  }

  switch (buttonType) {
    case 'action':
      return <El.PageHeaderActionButton
        size='large'
        loading={loadingExport}
        disabled={loadingExport}
        onClick={() => handleExport()}
        {...buttonProps}
      >
        {props.name || t('Export')}
      </El.PageHeaderActionButton>
    case 'button':
      return <Button
        loading={loadingExport}
        disabled={loadingExport}
        onClick={() => handleExport()}
        {...buttonProps}
      >
        {props.name || t('Export')}
      </Button>
    case 'popup':
      return <PopupWrapper>
        <Popup
          content={props.popupContent}
          trigger={<Button
            size='large'
            loading={loadingExport}
            disabled={loadingExport}
            icon={Boolean(props.icon)}
            labelPosition={'left'}
            onClick={() => handleExport()}
            {...buttonProps}
          >
            {props.icon && <Icon name={props.icon as SemanticICONS} />}
            {props.name || t('Export')}
          </Button>}
        />
      </PopupWrapper>
    case 'icon':
      return <El.PageHeaderActionButton
        size='large'
        loading={loadingExport}
        disabled={loadingExport}
        labelPosition={'left'}
        icon={props.icon}
        content={props.name || t('Export')}
        onClick={() => handleExport()}
        {...buttonProps}
      />
    default:
      return <El.PageHeaderActionButton
        size='large'
        loading={loadingExport}
        disabled={loadingExport}
        onClick={() => handleExport()}
        {...buttonProps}
      >
        {props.icon && <Icon name={props.icon as SemanticICONS} />}
        {props.name || t('Export')}
      </El.PageHeaderActionButton>
  }
}
export default ExcelExport